module.exports = __webpack_public_path__ + "static/media/default_reward_item.d7f86e42.png";